export const GET_SINGLE_SELECTED_SUBSCRIBER_REQ = 'GET_SINGLE_SELECTED_SUBSCRIBER_REQ'
export const GET_SINGLE_SELECTED_SUBSCRIBER_SUCC = 'GET_SINGLE_SELECTED_SUBSCRIBER_SUCC'
export const GET_SINGLE_SELECTED_SUBSCRIBER_FAIL = 'GET_SINGLE_SELECTED_SUBSCRIBER_FAIL'
export const RESET_SINGLE_SUBSCRIBER = 'RESET_SINGLE_SUBSCRIBER'